import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const sentPaths = new Set<string>();
export const GAListener = () => {
    const location = useLocation();
    useEffect(() => {
        if ((window as any).gtag && !sentPaths.has(location.pathname)) {
            sentPaths.add(location.pathname);
            (window as any).gtag("event", "page_view", {
                page_path: location.pathname,
                page_location: window.location.href,
                page_title: UpdateTitle(location.pathname),
            });
        }
    }, [location.pathname]);
    return null;
};


const UpdateTitle = (path: string) => {
    return path === "/" ? "Home" : path.replace(/^\//, "")
        .replaceAll(/-/g, " ")
        .split(" ")
        .map(word => word ? word[0].toUpperCase() + word.slice(1) : "")
        .join(" ");
};